import { render } from "./ChatsProfile.vue?vue&type=template&id=6ea59a41&scoped=true"
import script from "./ChatsProfile.vue?vue&type=script&lang=js"
export * from "./ChatsProfile.vue?vue&type=script&lang=js"

import "./ChatsProfile.vue?vue&type=style&index=0&id=6ea59a41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea59a41"]])

export default __exports__